
export const riskProviderKrn = "krn:kizi:data-provider:risk";
export const moneyViewProviderKrn = "krn:kizi:data-provider:moneyview";
export const breedBandWinkelProviderKrn = "krn:kizi:data-provider:breedbandwinkel";
export const zorgWebProviderKrn = "krn:kizi:data-provider:zorgweb";
export const salesdockProviderKrn = "krn:kizi:data-provider:salesdock";
export const zorgKaartProviderKrn = "krn:kizi:data-provider:zorgkaart";
export const kpnProviderKrn = "krn:kizi:data-provider:kpn";
export const budgetThuisProviderKrn = "krn:kizi:data-provider:budgetthuis";
export const deltaProviderKrn = "krn:kizi:data-provider:delta";
export const caiwayProviderKrn = "krn:kizi:data-provider:caiway";
export const youfoneProviderKrn = "krn:kizi:data-provider:youfone";
export const ziggoProviderKrn = "krn:kizi:data-provider:ziggo";
export const onlineNlProviderKrn = "krn:kizi:data-provider:online";
export const odidoProviderKrn = "krn:kizi:data-provider:odido";
export const rollsProviderKrn = "krn:kizi:data-provider:rolls";
export const achmeaProviderKrn = "krn:kizi:data-provider:achmea";
export const insharedProviderKrn = "krn:kizi:data-provider:inshared";
export const allianzDirectProviderKrn = "krn:kizi:data-provider:allianzdirect";
export const ominimoProviderKrn = "krn:kizi:data-provider:ominimo";
export const overstappenProviderKrn = "krn:kizi:data-provider:overstappen";

export const dataProviders = [riskProviderKrn, moneyViewProviderKrn, breedBandWinkelProviderKrn, zorgWebProviderKrn, salesdockProviderKrn, zorgKaartProviderKrn, kpnProviderKrn, budgetThuisProviderKrn, deltaProviderKrn, caiwayProviderKrn, youfoneProviderKrn, ziggoProviderKrn, onlineNlProviderKrn, odidoProviderKrn, rollsProviderKrn, achmeaProviderKrn, insharedProviderKrn, allianzDirectProviderKrn, ominimoProviderKrn,overstappenProviderKrn];

export const tenants = [
	"Kizi",
	"Overstappen",
	"Dyme",
	"Consumentenbond",
	"Swift",
	"AbnAmro",
	"autoverzekeringnl",
	"woolsocks",
	"geldnl",
	"porterenee"
];

export const productCategories = [
	"Non_Specific",
	"Car",
	"BUSINESS_CAR",
	"Energy",
	"Home",
	"Liability",
	"Triple_Play",
	"Travel",
	"Health_Care",
	"Solar_Panels",
	"Savings",
	"Event_Based",
	"BUSINESS_LIABILITY_INSURANCE",
	"BUSINESS_VAN",
	"BUSINESS_DAMAGE",
	"BUSINESS_ADDITIONAL_COSTS",
	"BUSINESS_LEGAL",
	"BUSINESS_COMPUTER_ELECTRONICS",
	"BUSINESS_INVENTORY",
	"BUSINESS_BUILDING",
	"BUSINESS_ACCIDENT"
];

export const orderTypes = [
	"Affiliate",
	"Funnel_Mga",
	"Not_Orderable",
];

export const supplierScoreSources = [
	"EerlijkeGeldWijzer",
	"VBDO"
];

export const productScoreSources = [
	"Consumentenbond",
	"Overstappen"
];

export const supplierStatuses = [
	"Active",
	"Deleted",
];

export const productStatuses = [
	"Active",
	"Deleted",
];

export const incentiveStatuses = [
	"Active",
	"Deleted",
	"Inactive"
];
